import { trackException } from "@/js/common-functions/application-insights";
import dayjs from "dayjs";

const storageKey = 'orderform-2025-code';

export const setCode = () => {
    try {
        const code = (new URLSearchParams(window.location.search)).get('referansekode');
        if(code) {
            const oldCode = getCode();
            if(oldCode != code) {
                window.localStorage.setItem(storageKey, JSON.stringify({ code, dateCreated: dayjs().toISOString() }));
                return true;
            }
        }
    } catch(err) {
        trackException(err);
        console.error('Failed to parse reference code', err);
    }
    return false;
};

export const getCode = () => {
    const codeData = window.localStorage.getItem(storageKey) ?? null;
    if(codeData) {
        try {
            const { code, dateCreated } = JSON.parse(codeData);
            if(code && dateCreated) {
                const dateDiff = dayjs().diff(dateCreated, 'hour');
                if(24 > dateDiff) {
                    return code;
                }
            }

            deleteCode();
        } catch(err) {
            trackException(err);
            console.error('Failed to parse reference code', err);
        }
    }

    return null;
};

export const deleteCode = () => {
    window.localStorage.removeItem(storageKey);
};
